import { ConfigLookupResolver, LookupResolver, Resolver, ResolverValue, ResolverFactory, LookupResolverValue } from '@behavior-management/core/types';
import { Variant } from '@behavior-management/core/constants';
import { FeatureId } from '@agoda/layout';
import { keys } from 'lodash';
import { ExperimentId } from 'core/type/ExperimentId';
import { getWindowLocation } from 'core/window/windowService';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { CommonHeaderProps } from 'core/type/header.types';

const InternalResolverFactory = (config: BootstrapConfig, header: CommonHeaderProps): ResolverFactory => ({
    getResolver(variant: Variant): Resolver {
        const newResolver = (get: () => ResolverValue) => ({ variant, get });
        switch (variant) {
            case Variant.Origin:
                return newResolver(() => config.pageConfig.origin);
            case Variant.Culture:
                return newResolver(() => config.pageConfig.cultureInfoName);
            case Variant.DeviceType:
                return newResolver(() => config.userDevice.deviceType);
            case Variant.WhiteLabelId:
                return newResolver(() => config.pageConfig.whitelabelid);
            case Variant.DomainName:
                return newResolver(() => getWindowLocation().hostname.toLowerCase());
            default:
                throw new Error(`No Resolver implemented for Variant: ${variant}`);
        }
    },
    getLookupResolver(variant: Variant): LookupResolver {
        const newLookupResolver = (getBy: (param?: ResolverValue) => LookupResolverValue) => ({ variant, getBy });
        switch (variant) {
            case Variant.Experiment:
                return newLookupResolver((exp?: ResolverValue) => (config.experiments[exp as ExperimentId] ? (exp as ExperimentId) : null));
            case Variant.WhiteLabelFeature:
                return newLookupResolver((wlFeature?: ResolverValue) => (header.featureConfigs[wlFeature as FeatureId] ? (wlFeature as string) : null));
            case Variant.ServerSideBehavior:
                return newLookupResolver((ssBehavior?: ResolverValue) => {
                    const behaviors = config?.behavior || {};
                    const behaviorKeys = keys(behaviors);
                    return behaviorKeys.some((b) => b === (ssBehavior as string)) ? (ssBehavior as string) : null;
                });
            default:
                throw new Error(`No LookupResolver implemented for Variant: ${variant}`);
        }
    },
    getConfigLookupResolver(): ConfigLookupResolver {
        return {
            getBy<T>(param: string) {
                return header.featureConfigs[param as FeatureId] as T;
            },
        };
    },
});

export default InternalResolverFactory;
